/**
 * Unified layout spacing tokens for consistent horizontal margins across the app.
 * 
 * Usage:
 * - Import and use with template literals: `className={SECTION_PADDING.full}`
 * - Or use inline: `className="px-5 md:px-12 xl:px-16"` (matches SECTION_PADDING.full)
 * 
 * Mobile: 20px (px-5)
 * Tablet: 48px (md:px-12)
 * Desktop: 64px (xl:px-16)
 */

export const SECTION_PADDING = {
  mobile: 'px-5',      // 20px
  tablet: 'md:px-12',  // 48px
  desktop: 'xl:px-16', // 64px
  full: 'px-5 md:px-12 xl:px-16'
} as const;

export const SCROLL_PADDING = {
  left: 'pl-5 md:pl-12 xl:pl-16',
  // Extra right padding for breathing room at end of carousels
  right: 'pr-8 md:pr-16 xl:pr-20',
  full: 'pl-5 md:pl-12 xl:pl-16 pr-8 md:pr-16 xl:pr-20'
} as const;

// Standard gap between books in carousels
export const CAROUSEL_GAP = {
  mobile: 'gap-2',     // 8px
  full: 'gap-2'
} as const;

// Unified thumbnail sizes for responsive breakpoints - larger for better visibility
export const THUMBNAIL_SIZE = {
  base: 'w-32',           // 128px mobile (was 112px)
  sm: 'sm:w-36',          // 144px small screens (was 128px)
  lg: 'lg:w-48',          // 192px desktop (was 160px)
  xl: 'xl:w-56',          // 224px large desktop (was 176px)
  full: 'w-32 sm:w-36 lg:w-48 xl:w-56'
} as const;

// Unified section title styling
export const SECTION_TITLE = {
  full: 'text-xl md:text-2xl font-apple font-bold text-white tracking-tight'
} as const;

// Unified horizontal scroll container styles
export const CAROUSEL_CONTAINER = {
  outer: 'relative overflow-x-hidden',
  scroll: 'overflow-x-auto scrollbar-hide scroll-smooth',
  inner: 'flex gap-2 pl-5 md:pl-12 xl:pl-16 pr-8 md:pr-16 xl:pr-20'
} as const;

// End spacer for carousel right padding
export const CAROUSEL_SPACER = 'flex-none w-8 md:w-12 xl:w-16';
